import { ContentfulBlock, ContentfulOrSidebarMenu } from 'types'
import { getRenderedBlocks } from '@utils/render'

export interface TmSidebarProps {
  sidebarMenu: ContentfulOrSidebarMenu
  blocks: ContentfulBlock[]
}

export const TmSidebar = ({ blocks }: TmSidebarProps) => {
  return <>{getRenderedBlocks(blocks)}</>
}
